<template>
  <v-container fluid class="add-crop fill-height">
    <ExitConfirmation
      v-show="exitConfirmationDialog"
      :exitConfirmationDialog.sync="exitConfirmationDialog"
      :backTo="{name: 'ManageField', params: {field}}"
    />
    <v-layout v-show="!exitConfirmationDialog" class="div-center-horizontally">
      <v-flex xs12>
        <v-container class="medium-div">
          <v-layout row class="header-row">
            <v-flex class="div-center-vertically">
              <p class="crop-data">{{$t('AddCrop.cropData')}}</p>
            </v-flex>
            <v-flex class="div-center-vertically div-right-horizontally">
              <v-btn icon @click="close">
                <v-icon class="close-icon">close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row class="crop-content-row">
            <CropEditor :cropData.sync="crop" :comesFromAnotherRoute="comesFromAnotherRoute" :comesFromAnotherRouteData="comesFromAnotherRouteData" :isNewCrop="isNewCrop" />
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CropEditor from './CropEditor'
import ExitConfirmation from './ExitConfirmation'

export default {
  components: {
    CropEditor,
    ExitConfirmation
  },
  data () {
    return {
      organization: this.$store.getters.userOrganization.name,
      exitConfirmationDialog: false,
      crop: this.$route.params.crop || {},
      field: {},
      comesFromAnotherRoute: this.$route.params.comesFromAnotherRoute || false,
      comesFromAnotherRouteData: this.$route.params.comesFromAnotherRouteData || {},
      isNewCrop: this.$route.params.isNewCrop
    }
  },
  created () {
    this.field = this.$store.getters.fields.find(field => field.id === this.crop.field)
  },
  methods: {
    close () {
      this.exitConfirmationDialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddCrop.vue?fba862b6